export default __webpack_public_path__ + "static/media/extra.40003f21.jpg";